import React from "react";
import { Typography, TextField, InputAdornment } from "@material-ui/core";
import { formatMoney } from "../../../lib/helperFuncs.jsx";

export const priceRenderer = (
    value,
    name,
    fieldUpdateHandler,
    isError,
    mutable,
    editable,
) => {
    if (editable === false) {
        return <Typography>{formatMoney(value)}</Typography>;
    }

    return mutable || typeof fieldUpdateHandler === "function" ? (
        <TextField
            value={value || ""}
            type="number"
            onChange={(e) => fieldUpdateHandler(name, e.target.value)}
            error={!!isError}
            helperText={isError}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">&#8381;</InputAdornment>
                ),
            }}
        />
    ) : (
        <Typography>{formatMoney(value)}</Typography>
    );
};
